<template>
  <div class="camera-capture">
    <button @click="startCamera" v-if="!isCameraOn">Buka Kamera</button>
    <video ref="video" width="320" height="240" autoplay v-show="isCameraOn"></video>
    <canvas ref="canvas" width="320" height="240" style="display: none;"></canvas>
    <button @click="takePicture" v-if="isCameraOn">Ambil Foto</button>
    <img :src="photo" v-if="photo && !isCameraOn" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      photo: null,
      videoStream: null,
      isCameraOn: false,
    };
  },
  methods: {
    startCamera() {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          this.videoStream = stream;
          this.$refs.video.srcObject = stream;
          this.isCameraOn = true;
        })
        .catch((error) => {
          console.error("Error accessing camera: ", error);
        });
    },
    takePicture() {
      const canvas = this.$refs.canvas;
      const video = this.$refs.video;
      const context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photo = canvas.toDataURL("image/png");
      this.stopCamera();
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());
        this.videoStream = null;
        this.isCameraOn = false;
      }
    },
  },
  beforeDestroy() {
    this.stopCamera();
  },
};
</script>

<style>
.camera-capture {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
</style>
